import { InstrumentTypeLogo } from '../ReactControls/elements/InstrumentTypeLogo';
import { ReactToRactiveAdapter } from '../ReactToRactiveAdapter';
export class InstrumentTypeLogoRactive extends ReactToRactiveAdapter {
    constructor() {
        super();
    }
    attachEventHandlers(props) {
        props.instrument = this.get('instrument');
        props.onClick = () => {
            this.fire('logoClick');
        };
    }
}
ReactToRactiveAdapter.extendWith(InstrumentTypeLogoRactive, {
    template: '<div class="js-tercera-lookup-ImgBtn"></div>',
    mountContainer: '.js-tercera-lookup-ImgBtn',
    reactComponent: InstrumentTypeLogo,
    data: function () {
        return {
            menuItems: [],
            contextProps: {}
        };
    }
});
